<template>
  <z-carousel
    :slides-per-group-mobile="1"
    :slides-per-group-desktop="1"
    :slides-per-view-mobile="1"
    :slides-per-view-desktop="1"
    :display-mobile-swiper="true"
    class="lesson-video-gallery"
    @swiped="onSwipe"
  >
    <div
      v-for="(video,index) in videos"
      :key="index"
      class="lesson-video-gallery__video"
      :style="currentVideo !== video.url ? { backgroundImage: `url(${getThumbnail(video.url)})` } : {}"
      @click="playVideo(video.url)"
      @keypress="playVideo(video.url)"
    >
      <z-icon
        v-show="currentVideo !== video.url"
        class="lesson-video-gallery__icon"
        :icon="['fab', 'youtube']"
      />

      <youtube
        v-if="currentVideo === video.url"
        ref="youtubeVideo"
        :video-id="video.url"
        :resize="false"
        width="100%"
        height="100%"
        class="lesson-video-gallery__player"
      />
    </div>
  </z-carousel>
</template>

<script>
import Vue from 'vue'
import VueYoutube from 'vue-youtube'

Vue.use(VueYoutube)

export default {
  name: 'LessonVideoGallery',
  props: {
    videos: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      currentVideo: null,
    }
  },
  methods: {
    playVideo (videoId) {
      this.currentVideo = videoId

      this.$nextTick(() => {
        this.$refs.youtubeVideo[0].player.playVideo()
      })
    },
    getThumbnail (videoId) {
      return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
    },
    onSwipe () {
      if (this.$refs.youtubeVideo?.length > 0) {
        this.$refs.youtubeVideo[0].player.destroy()
      }

      this.currentVideo = null
    },
  },
}
</script>

<style lang="scss" scoped>
.lesson-video-gallery {
  @media (min-width: $breakpoint-tablet) {
    margin-left: auto;
    margin-right: auto;
    max-width: 760px;
  }
}

.lesson-video-gallery__video {
  background: var(--color-gray-900);
  cursor: pointer;
  height: 280px;
  position: relative;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  margin-right: 0 !important;

  @media (min-width: $breakpoint-tablet) {
    height: 450px;
  }

  &:hover {
    & .lesson-video-gallery__icon {
      color: var(--color-font-major);
    }
  }
}

.z-carousel__swiper-wrapper {
  padding: 0 !important;
}

.lesson-video-gallery__icon {
  --z-icon-area: var(--unit-2800);
  --z-icon-size: var(--unit-2800);

  color: var(--color-social-youtube-pure);
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
